export enum UserType {
  Sender = 'sender',
  Traveller = 'traveler',
}
